module.exports = __webpack_public_path__ + "img/jishuqiye-logo.0e432271.png";